<template>
    <div class="block-editor google-play-update-review-status">
        <section>
            <div class="title">Review ID</div>
            <TiptapEditor placeholder="Google Play Review ID" :show-attributes="true" v-model="clone.reviewId" automation-mode />
            <small>Durumu güncellenecek yorumun ID'si</small>
        </section>
        <section>
            <div class="title">Yeni Durum</div>
            <a-select v-model="clone.status" class="classic-select" placeholder="Durum seçiniz">
                <a-select-option value="new">Yeni (new)</a-select-option>
                <a-select-option value="replied">Yanıtlandı (replied)</a-select-option>
                <a-select-option value="resolved">Çözüldü (resolved)</a-select-option>
            </a-select>
        </section>
        <section>
            <div class="title">Atanacak Temsilci (Opsiyonel)</div>
            <a-select v-model="clone.assigneeId" class="classic-select" placeholder="Temsilci seçiniz" allow-clear>
                <a-select-option v-for="user in users" :key="user._id" :value="user._id">
                    {{ user.name }}
                </a-select-option>
            </a-select>
            <small>Yorumu bir temsilciye atayabilirsiniz</small>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "GooglePlayUpdateReviewStatus",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                reviewId: "",
                status: "new",
                assigneeId: null,
                ...this.value
            }),
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.google-play-update-review-status {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    .classic-select {
        width: 100%;
    }

    small {
        color: #777;
    }
}
</style>
